import { Chip, Stack, Typography } from '@mui/material';
import localStrings from "../../../localStrings";

const options = [
  {
    label: localStrings.blendIn,
    value: 'blend-in'
  },
  {
    label: localStrings.discreet,
    value: 'discreet'
  },
  {
    label: localStrings.evident,
    value: 'evident'
  }
];

export const OptionsNavColor = (props) => {
  const { onChange, value } = props;

  return (
    <Stack spacing={1}>
      <Typography
        color="text.secondary"
        variant="overline"
      >
          {localStrings.navColor}
      </Typography>
      <Stack
        alignItems="center"
        direction="row"
        flexWrap="wrap"
        gap={2}
      >
        {options.map((option) => (
          <Chip
            key={option.label}
            label={option.label}
            onClick={() => onChange?.(option.value)}
            sx={{
              borderColor: 'transparent',
              borderRadius: 1.5,
              borderStyle: 'solid',
              borderWidth: 2,
              ...(option.value === value && {
                borderColor: 'primary.main'
              })
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
};
